import { render, staticRenderFns } from "./AssignTo.vue?vue&type=template&id=7814a8a0&"
import script from "./AssignTo.vue?vue&type=script&lang=js&"
export * from "./AssignTo.vue?vue&type=script&lang=js&"
import style0 from "./AssignTo.vue?vue&type=style&index=0&id=7814a8a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports